import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import { useCallback, useMemo } from 'react';
import getIneligibleContactReason from 'sequences-lib/lib/getIneligibleContactReason';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { OK } from 'sequences-lib/constants/SubscriptionStatusTypes';
import { cannotEnrollSequenceLearnMore } from 'sequences-lib/lib/links';
import formatName from 'I18n/utils/formatName';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Typeahead } from 'foundations-components/transitional/components/Typeahead';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Flex } from 'foundations-components/components/Flex';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomItemComponent = props => {
  const {
      option
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: option === null || option === void 0 ? void 0 : option.dropdownText,
    placement: "right",
    disabled: !(option !== null && option !== void 0 && option.disabled),
    children: /*#__PURE__*/_jsxs(View, Object.assign({
      as: "div",
      textAlign: "left",
      paddingBlock: "300",
      paddingInline: "400"
    }, rest, {
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlock: "0",
        paddingBlock: "100",
        children: option === null || option === void 0 ? void 0 : option.text
      }), (option === null || option === void 0 ? void 0 : option.value) && (option === null || option === void 0 ? void 0 : option.value) !== '__EMPTY_OPTION__' && /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        margin: "0",
        children: [/*#__PURE__*/_jsx(EmailIcon, {
          color: "fill-info-default"
        }), /*#__PURE__*/_jsx(Text, {
          as: "span",
          marginInlineStart: "200",
          typography: "detail-100",
          color: option !== null && option !== void 0 && option.disabled ? 'text-primary-disabled' : 'text-core-default',
          children: option === null || option === void 0 ? void 0 : option.value
        })]
      })]
    }))
  });
};
export default function useEnrollInSequencePopover({
  onSequenceButtonClick,
  contacts,
  eligibilities
}) {
  const handleSequenceButtonClick = useCallback(recipient => {
    onSequenceButtonClick(recipient);
  }, [onSequenceButtonClick]);
  const renderedContactList = useMemo(() => {
    const contactOptions = contacts.map(contact => {
      const email = getProperty(contact, 'email');
      const firstName = getProperty(contact, 'firstname');
      const lastName = getProperty(contact, 'lastname');
      const vid = contact.get('vid');
      const reason = eligibilities ? getIneligibleContactReason({
        contact,
        eligibility: eligibilities.get(`${vid}`)
      }) : OK;
      const isButtonDisabled = Boolean(reason && reason !== OK);
      const learnMoreLink = /*#__PURE__*/_jsx(Link, {
        href: cannotEnrollSequenceLearnMore(),
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createActivityButtons.tooltip.sequenceDisabled.learnMoreText"
        })
      });
      const tooltipMessage = isButtonDisabled ? reason ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `createActivityButtons.tooltip.sequenceDisabled.${reason.toLowerCase()}`,
        options: {
          learnMoreLink
        }
      }) : learnMoreLink : null;
      const option = {
        dropdownText: tooltipMessage,
        value: email || `${vid}`,
        text: formatName({
          firstName,
          lastName
        }),
        disabled: isButtonDisabled
      };
      return option;
    }).toArray();
    return /*#__PURE__*/_jsx(Typeahead, {
      options: contactOptions,
      itemComponent: CustomItemComponent,
      enableKeyboardScrollingNav: true,
      onChange: evt => {
        var _evt$target;
        return handleSequenceButtonClick(evt === null || evt === void 0 || (_evt$target = evt.target) === null || _evt$target === void 0 || (_evt$target = _evt$target.value) === null || _evt$target === void 0 ? void 0 : _evt$target.toString());
      }
    });
  }, [contacts, eligibilities, handleSequenceButtonClick]);
  return [renderedContactList];
}